(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/store/atoms.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/store/atoms.js');
'use strict';

const _jotai = jotai,
  atom = _jotai.atom;
const _svs$self_exclusion_r = svs.self_exclusion_react.data,
  activeSelfExclusions = _svs$self_exclusion_r.activeSelfExclusions,
  isNaExcluded = _svs$self_exclusion_r.isNaExcluded;
const selfExclusionAtoms = {
  activeExclusionsAtom: atom(activeSelfExclusions),
  isNaExcludedAtom: atom(isNaExcluded)
};
svs.selfExclusion.store.selfExclusionAtoms = selfExclusionAtoms;

 })(window);